import axios from "axios";
import { API_BASE_URL, FETCH_LIMIT } from "./../../globalVars";

export default {
  namespaced: true,

  actions: {
    async hydrate({ commit }) {
      const store = this;
      const last = this.getters["entities/settings/query"]().first()
        .lastUpdateFromServer;
      await fetchNext({
        store: store,
        offset: 0,
        lastDateTime: last
      });
    },
    async createAddress(context, address) {
      if (address.isDirty === true) {
        const store = this;
        try {
          let response = await axios({
            method: "post",
            url: API_BASE_URL + `/address`,
            data: {
              accountId: address.accountId,
              customerId: address.customerId,
              type: address.type ? address.type : "main",
              address1: address.address1,
              address2: address.address2,
              city: address.city,
              state: address.state,
              postalCode: address.postalCode
            },
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`
            }
          });
          store.dispatch("entities/addresses/delete", {
            where: address.tempId
          });
          store.dispatch("entities/addresses/insert", {
            where: parseInt(response.id),
            data: response.data
          });
          store.dispatch("entities/customers/fetchCustomerDataJoins", {
            joins: "addresses",
            customerId: address.customerId
          });
          store.dispatch("entities/settings/setIsOffline", false);
        } catch (error) {
          store.dispatch("entities/settings/setIsOffline", true);
        }
      }
    },
    async updateAddress(context, address) {
      if (address.isDirty === true) {
        const store = this;
        try {
          let response = await axios({
            method: "patch",
            url: API_BASE_URL + `/address/${address.id}`,
            data: {
              accountId: address.accountId,
              id: address.id,
              type: address.type,
              address1: address.address1,
              address2: address.address2,
              city: address.city,
              state: address.state,
              postalCode: address.postalCode
            },
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`
            }
          });
          store.dispatch("entities/addresses/update", {
            where: response.id,
            data: response.data
          });
          store.dispatch("entities/settings/setIsOffline", false);
        } catch (error) {
          store.dispatch("entities/settings/setIsOffline", true);
        }
      }
    },
    async deleteAddress(context, address) {
      const store = this;
      store.dispatch("entities/addresses/delete", address.id);

      if (address.isDirty === true) {
        try {
          await axios({
            method: "patch",
            url: API_BASE_URL + `/address/${address.id}`,
            data: {
              accountId: address.accountId,
              id: address.id,
              deleted: true
            },
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`
            }
          });
          store.dispatch("entities/settings/setIsOffline", false);
        } catch (error) {
          store.dispatch("entities/settings/setIsOffline", true);
        }
      }
    }
  }
};

async function fetchNext({ store, offset, lastDateTime = 0 }) {
  try {
    let response = await axios({
      method: "get",
      url:
        API_BASE_URL +
        `/address?updatedAt[$gt]=${lastDateTime}&$limit=${FETCH_LIMIT}&$skip=${offset}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access_token")}`
      }
    });
    const obj = response.data.data;
    const maxRows = response.data.total;
    let addresses = [];
    obj.forEach(function(address) {
      addresses.push({
        id: parseInt(address.id),
        isDirty: false,
        customerId: address.customerId,
        type: address.type,
        address1: address.address1,
        address2: address.address2,
        city: address.city,
        state: address.state,
        postalCode: address.postalCode,
        createdAt: Date.parse(address.createdAt),
        updatedAt: Date.parse(address.updatedAt)
      });
    });
    if (addresses.length > 0) {
      store.dispatch("entities/addresses/insert", {
        data: addresses
      });
    }
    store.dispatch("entities/settings/setIsOffline", false);
    if (maxRows > FETCH_LIMIT + offset) {
      await fetchNext({
        store,
        offset: FETCH_LIMIT + offset,
        lastDateTime
      });
    }
  } catch (error) {
    store.dispatch("entities/settings/setIsOffline", true);
  }
}
